import { fetchData, ENDPOINT_HOST } from './api_helper';

const apiURL = `${ENDPOINT_HOST}`;

const fetchSites = (partnerId, page, keyword = '', orderInfo, isMobile) => new Promise(((resolve, reject) => {
  let endpointURL = `${apiURL}partners/${partnerId}/sites?page=${page}&term=${keyword}`;
  if (orderInfo) {
    endpointURL = `${apiURL}partners/${partnerId}/sites?page=${page}&term=${keyword}&order=${orderInfo.order}&direction=${orderInfo.direction}`;
  }

  if (isMobile) {
    endpointURL = `${apiURL}partners/${partnerId}/sites?mobile=${isMobile}`;
  }
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchSite = (partnerId, id) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}partners/${partnerId}/sites/${id}`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const updateSite = (partnerId, params) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}partners/${partnerId}/sites/${params.id}`;
  const formData = new FormData();
  Object.keys(params).forEach((k) => {
    if (params[k] != undefined && params[k] != null && params[k] != 'null') {
      formData.append(k, params[k]);
    }
  });
  fetchData(endpointURL, 'put', formData, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const createSite = (partnerId, params) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}partners/${partnerId}/sites`;
  const formData = new FormData();
  Object.keys(params).forEach((k) => {
    if (params[k] != undefined && params[k] != null && params[k] != 'null') {
      formData.append(k, params[k]);
    }
  });
  fetchData(endpointURL, 'post', formData, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const deleteSite = (partnerId, id) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}partners/${partnerId}/sites/${id}`;
  fetchData(endpointURL, 'delete', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));


export default {
  fetchSites,
  fetchSite,
  updateSite,
  createSite,
  deleteSite,
};



// WEBPACK FOOTER //
// ./src/api/sites.js